import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import RifacimentiBagniSection from "../components/RifacimentiBagniSection";
import SerramentiSection from "../components/SerramentiSection";
import VetratePanoramicheSection from "../components/VetratePanoramicheSection";
import RistrutturazioniPrestigioSection from "../components/RistrutturazioniPrestigioSection";
import RassegnaStampaSection from "../components/RassegnaStampaSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <RifacimentiBagniSection />
      <SerramentiSection />
      <VetratePanoramicheSection />
      <RistrutturazioniPrestigioSection />
      <RassegnaStampaSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default Home;